export const tableHeadAppoint = [
  { key: "number", value: "Номер заявки", isActive: true  },
  { key: "unit", value: "Подразделение", isActive: true  },
  { key: "object", value: "Объект", isActive: true  },
  { key: "contractor", value: "Исполнитель", isActive: true  },
  { key: "builder", value: "Подрядчик", isActive: true  },
  { key: "status", value: "Статус заявки", isActive: true  },
  { key: "problemDescription", value: "Описание проблемы", isActive: true  },
  { key: "photo", value: "Фото/Видео проблемы", isActive: true  },
  { key: "itineraryOrder", value: "Порядок маршрута", isActive: true  },
  { key: "urgency", value: "Срочность", isActive: true  },
  { key: "createdAt", value: "Дата создания заявки", isActive: true  },
  { key: "daysAtWork", value: "Дней в работе", isActive: true  },
  { key: "planCompleteDate", value: "Плановая дата выполнения", isActive: true  },
  { key: "completeDate", value: "Дата выполнения (факт)", isActive: true  },
  { key: "repairPrice", value: "Бюджет ремонта", isActive: true  },
  { key: "comment", value: "Комментарий", isActive: true  },
  { key: "commentAttachment", value: "Вложение к комментарию", isActive: true  },
  { key: "legalEntity", value: "Юр. Лицо", isActive: true  },
  { key: "checkPhoto", value: "Фото чека", isActive: true  },
]; 

export const phoneHeaderData = [
  { key: "fileName", value: "Фото/Видео проблемы", isActive: true  },
  { key: "number", value: "Номер заявки", isActive: true  },
  { key: "unit", value: "Подразделение", isActive: true  },
  { key: "object", value: "Объект", isActive: true  },
  { key: "contractor", value: "Исполнитель", isActive: true  },
  { key: "builder", value: "Подрядчик", isActive: true  },
  { key: "status", value: "Статус заявки", isActive: true  },
  { key: "problemDescription", value: "Описание проблемы", isActive: true  },
  { key: "itineraryOrder", value: "Порядок маршрута", isActive: true  },
  { key: "urgency", value: "Срочность", isActive: true  },
  { key: "createdAt", value: "Дата создания заявки", isActive: true  },
  { key: "daysAtWork", value: "Дней в работе", isActive: true  },
  { key: "planCompleteDate", value: "Плановая дата выполнения", isActive: true  },
  { key: "completeDate", value: "Дата выполнения (факт)", isActive: true  },
  { key: "repairPrice", value: "Бюджет ремонта", isActive: true  },
  { key: "comment", value: "Комментарий", isActive: true  },
  { key: "legalEntity", value: "Юр. Лицо", isActive: true  },
]; 


export const tableList = [
  { key: "number", value: "Номер заявки", isActive: true  },
  { key: "contractor", value: "Исполнитель", isActive: true  },
  { key: "object", value: "Объект", isActive: true  },
  { key: "builder", value: "Подрядчик", isActive: true  },
  { key: "status", value: "Статус заявки", isActive: true  },
  { key: "unit", value: "Подразделение", isActive: true  },
  { key: "problemDescription", value: "Описание проблемы", isActive: true  },
  { key: "photo", value: "Фото проблемы", isActive: true  },
  { key: "itineraryOrder", value: "Порядок маршрута", isActive: true  },
  { key: "urgency", value: "Срочность", isActive: true  },
  { key: "createdAt", value: "Дата создания заявки", isActive: true  },
  { key: "daysAtWork", value: "Дней в работе", isActive: true  },
  { key: "completeDate", value: "Дата выполнения (факт)", isActive: true  },
  { key: "repairPrice", value: "Бюджет ремонта", isActive: true  },
  { key: "comment", value: "Комментарий", isActive: true  },
  { key: "legalEntity", value: "Юр. Лицо", isActive: true  },
]

